// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkuBundleInfo_sku-bundle-info__g5Bsj {
  flex-grow: 1;
  padding-block: 5rem;
}

.SkuBundleInfo_sku-bundle-info__title__IadT0 {
  color: var(--gray-dark);
  font-size: var(--text-base);
  font-weight: 500;
  margin-bottom: 2rem;
}

.SkuBundleInfo_sku-bundle-info__breadcrumb__m2qks {
  font-size: var(--text-base);
  margin-block: 2rem;
}

.SkuBundleInfo_sku-bundle-info__name__o1akt {
  color: #000;
  font-size: var(--text-xl);
  font-weight: 500;
  margin-bottom: 2.5rem;
}

.SkuBundleInfo_sku-bundle-info__price-wrapper__5SVZr {
  display: flex;
  align-items: center;
  gap: 4rem;
  margin-bottom: 3rem;
}

.SkuBundleInfo_sku-bundle-info__price__1d7gh {
  color: var(--primary-color);
  font-size: var(--text-lg);
  font-weight: 700;
}

.SkuBundleInfo_sku-bundle-info__price-currency__Gvf9L {
  font-size: var(--text-sm);
}

.SkuBundleInfo_sku-bundle-info__bundle-tag__ChT0b {
  background-color: var(--sky);
  color: var(--primary-color);
  border: 0.1rem solid var(--primary-color);
  border-radius: 0.4rem;
  padding: 0.4rem;
  font-size: var(--text-xs);
  font-weight: 700;
}

.SkuBundleInfo_sku-bundle-info__bundle-tag__ChT0b:hover {
  text-decoration: underline;
}

.SkuBundleInfo_sku-bundle-info__quantity__n2kNg {
  color: var(--gray-dark);
  font-size: var(--text-base);
  font-weight: 500;
  margin-bottom: 1.5rem;
}

.SkuBundleInfo_sku-bundle-info__controls__IOmKj {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.SkuBundleInfo_sku-bundle-info__primary-btn__yjpns {
  padding: 1.2rem 6rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/SkuBundleDetails/SkuBundleInfo/SkuBundleInfo.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".sku-bundle-info {\n  flex-grow: 1;\n  padding-block: 5rem;\n}\n\n.sku-bundle-info__title {\n  color: var(--gray-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n  margin-bottom: 2rem;\n}\n\n.sku-bundle-info__breadcrumb {\n  font-size: var(--text-base);\n  margin-block: 2rem;\n}\n\n.sku-bundle-info__name {\n  color: #000;\n  font-size: var(--text-xl);\n  font-weight: 500;\n  margin-bottom: 2.5rem;\n}\n\n.sku-bundle-info__price-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4rem;\n  margin-bottom: 3rem;\n}\n\n.sku-bundle-info__price {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  font-weight: 700;\n}\n\n.sku-bundle-info__price-currency {\n  font-size: var(--text-sm);\n}\n\n.sku-bundle-info__bundle-tag {\n  background-color: var(--sky);\n  color: var(--primary-color);\n  border: 0.1rem solid var(--primary-color);\n  border-radius: 0.4rem;\n  padding: 0.4rem;\n  font-size: var(--text-xs);\n  font-weight: 700;\n}\n\n.sku-bundle-info__bundle-tag:hover {\n  text-decoration: underline;\n}\n\n.sku-bundle-info__quantity {\n  color: var(--gray-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n  margin-bottom: 1.5rem;\n}\n\n.sku-bundle-info__controls {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.sku-bundle-info__primary-btn {\n  padding: 1.2rem 6rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sku-bundle-info": `SkuBundleInfo_sku-bundle-info__g5Bsj`,
	"sku-bundle-info__title": `SkuBundleInfo_sku-bundle-info__title__IadT0`,
	"sku-bundle-info__breadcrumb": `SkuBundleInfo_sku-bundle-info__breadcrumb__m2qks`,
	"sku-bundle-info__name": `SkuBundleInfo_sku-bundle-info__name__o1akt`,
	"sku-bundle-info__price-wrapper": `SkuBundleInfo_sku-bundle-info__price-wrapper__5SVZr`,
	"sku-bundle-info__price": `SkuBundleInfo_sku-bundle-info__price__1d7gh`,
	"sku-bundle-info__price-currency": `SkuBundleInfo_sku-bundle-info__price-currency__Gvf9L`,
	"sku-bundle-info__bundle-tag": `SkuBundleInfo_sku-bundle-info__bundle-tag__ChT0b`,
	"sku-bundle-info__quantity": `SkuBundleInfo_sku-bundle-info__quantity__n2kNg`,
	"sku-bundle-info__controls": `SkuBundleInfo_sku-bundle-info__controls__IOmKj`,
	"sku-bundle-info__primary-btn": `SkuBundleInfo_sku-bundle-info__primary-btn__yjpns`
};
export default ___CSS_LOADER_EXPORT___;
